import Axios from 'axios';
import { API_PREFIX, BASE_URL, LOCAL_HOST } from '../config/apiConfig';
// import Product from './resources/Product';
// import AgencyGroup from './resources/AgencyGroup';
// import AgencyUsers from './resources/AgencyUsers';

class ApiClientSingleton {
  constructor() {
    // Ensure HTTPS is used for API calls
    const baseURL = BASE_URL.startsWith('http://') && BASE_URL.includes(LOCAL_HOST)
      ? BASE_URL
      : BASE_URL.replace('http://', 'https://');

    const httpConfig = {
      baseURL: baseURL + API_PREFIX,
      // Do not set a global Content-Type; allow axios to set per-request
      headers: {
        Pragma: 'no-cache'
      },
      // Handle proxy configuration
      proxy: false, // Disable axios internal proxy handling
      timeout: 30000, // 30 second timeout
    };
    this.httpClient = Axios.create(httpConfig);

    // Add request interceptor to ensure HTTPS and correct FormData handling
    this.httpClient.interceptors.request.use(
      (config) => {
        // If sending FormData, let the browser set proper multipart boundary
        const isFormData = typeof FormData !== 'undefined' && config.data instanceof FormData;
        if (isFormData) {
          // Ensure axios does NOT stringify FormData
          config.transformRequest = [(data) => data]; // eslint-disable-line no-param-reassign

          const configHeaders = config.headers;
          if (configHeaders) {
            // Axios v1 uses AxiosHeaders helper with delete() API; handle both shapes
            try {
              if (typeof configHeaders.delete === 'function') {
                configHeaders.delete('Content-Type');
                configHeaders.delete('content-type');
              } else {
                // Remove any preset Content-Type so the browser can apply one
                delete configHeaders['Content-Type'];
                delete configHeaders['content-type'];
                if (configHeaders.common) {
                  delete configHeaders.common['Content-Type'];
                  delete configHeaders.common['content-type'];
                }
                if (configHeaders.post) {
                  delete configHeaders.post['Content-Type'];
                  delete configHeaders.post['content-type'];
                }
              }
            } catch (e) {
              // best-effort; continue regardless
              console.warn('Could not delete Content-Type from headers', e); // eslint-disable-line no-console
            }
          }
        }
        // ME - test without https
        // Ensure all URLs use HTTPS when targeting travelport.com
        let updatedUrl = config.url;
        if (typeof updatedUrl === 'string' && !updatedUrl.includes(LOCAL_HOST)) {
          updatedUrl = updatedUrl.replace('http://', 'https://');
        }

        let updatedBaseURL = config.baseURL;
        if (typeof updatedBaseURL === 'string' && !updatedBaseURL.includes(LOCAL_HOST)) {
          updatedBaseURL = updatedBaseURL.replace('http://', 'https://');
        }
        return {
          ...config,
          url: updatedUrl,
          baseURL: updatedBaseURL
        };
      },
      (error) => Promise.reject(error)
    );

    // this.product = new Product(this.httpClient, '/application/BrowseProduct');
    // this.agencyGroup = new AgencyGroup(this.httpClient, '/groups');
    // this.agencyUser = new AgencyUsers(this.httpClient, '');
  }

  static get instance() {
    return this._instance || new ApiClientSingleton();
  }
}

const ApiClient = ApiClientSingleton.instance;
export default ApiClient;
